import { Button } from 'components/Button'
import { Spinner } from 'common/Spinner/Spinner'
import Styles from '../../../Prompt.module.scss'
import giphyLogo from '../../images/giphy_logo.png'

interface Props {
  stagedImagesCount: number
  selectedImagesCount: number
  loading: boolean
  renderGiphyLogo: boolean
  multiSelect?: boolean
  onSuccess: () => void
  onCancel: () => void
  forceShow?: boolean
}

const PromptFooter = ({
  stagedImagesCount,
  selectedImagesCount,
  loading,
  renderGiphyLogo,
  multiSelect,
  onSuccess,
  onCancel,
  forceShow,
}: Props) => {
  if (stagedImagesCount === 0 && !forceShow) return null

  const buttonText = multiSelect ? 'Add images' : 'Add image'

  return (
    <div className={Styles.footerWrapper}>
      <span>{selectedImagesCount} selected</span>

      {renderGiphyLogo && <img src={giphyLogo} alt="Powered by Giphy" className={Styles.giphyLogo} />}

      <div className={Styles.footerActions}>
        <Button onPress={onCancel} isDisabled={loading} variant="secondary" size="sm" className={Styles.cancelButton}>
          Cancel
        </Button>
        <Button id="uploadImages" onPress={onSuccess} size="sm" isDisabled={loading || selectedImagesCount === 0}>
          {loading ? <Spinner /> : buttonText}
        </Button>
      </div>
    </div>
  )
}

export default PromptFooter
